import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';
import { GeneralTaskService } from 'src/app/services/task/general-task.service';
import { GeneralService } from 'src/app/services/general.service';
import * as $ from 'jquery';
import { LogActivityService } from 'src/app/services/settings-services/log-activity.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-view-my-tasks',
  templateUrl: './view-my-tasks.component.html',
  styleUrls: ['./view-my-tasks.component.css']
})

export class ViewMyTasksComponent implements OnInit, OnDestroy {
  private unsubscribe = new Subject<any>();
  p: number = 1;
  id: any;
  org: any;
  task: any;
  user: any;
  comment: string;
  type: any;
  selection: any;
  activityLogs;
  commentList: any;
  isLoading: boolean = false;
  commentLoading: boolean = false;
  loader: any = {
    default: "notch-loader",
    spinnerType: "",
    spinnerStyle: {},
    dataless: {
      title: "No Data Available!",
      subTitle: "Please  try again",
      action: "Load Teams",
      success: true
    },
    showSpinner: false
  };

  constructor(
    route: ActivatedRoute,
    store: Store<AppState>,
    private logActSrv: LogActivityService,
    private generalSrv: GeneralService,
    private generalTaskSrv: GeneralTaskService,
  ) {
    this.loader.spinnerType = this.loader.default;
    this.id = route.snapshot.paramMap.get("id");
    store.select("userInfo").subscribe(info => {
      this.org = info.organization;
      this.user = info.user;
    });
  }

  ngOnInit() {
    this.generalSrv.showSpinner.next(false);
    this.fetchTaskByID();
    this.fetchLogActivityTypes();
    this.getTaskComment();

    //refresh Types
    this.logActSrv.refreshNeeded$
      .subscribe(() => {
        this.fetchLogActivityTypes();
      })
    this.generalTaskSrv.refreshNeeded$
      .subscribe(() => {
        this.getTaskComment();
        this.fetchTaskComment();
      })
  }

  //ACTIVITY TYPE

  /**
   * Fetch Activity Type
   */
  private fetchLogActivityTypes() {
    this.logActSrv.getActivityTypes().pipe(takeUntil(this.unsubscribe)).subscribe(activityLogs => {
      this.activityLogs = activityLogs;
    })
  }

  //TASK INFO

  /**
   * Fetch Task By ID
   * @param id 
   */
  fetchTaskByID() {
    this.loader.showSpinner = true;
    this.generalTaskSrv.getTaskByID(this.id).pipe(takeUntil(this.unsubscribe)).subscribe(task => {
      this.initializeLoad(task);
      this.loader.showSpinner = false;
    })
  }

  fetchTaskComment() {
    this.generalTaskSrv.getTaskByID(this.id).pipe(takeUntil(this.unsubscribe)).subscribe(task => {
      this.initializeLoad(task);
    })
  }

  createComment() {
    const type = this.selection || this.type.name;
    if (!type) {
      $(`#closeComment`).click();
      $(`#closeComment2`).click();
      this.generalSrv.sweetAlertError("All Field's are Required")
    } else {
      const payload = {
        comment: this.comment,
        commentCategory: type,
        orgID: this.org.id,
        taskID: this.id,
        userID: this.user.id
      }
      this.commentLoading = true;
      this.generalTaskSrv.commentOnTask(payload).pipe(takeUntil(this.unsubscribe)).subscribe((data: any) => {
        if (type == "COMPLETED") {
          this.commentLoading = false;
          this.markTaskAsCompleted(this.id); 
          $(`#closeComment`).click();
          $(`#closeComment2`).click();
        } else if (type == "VOIDED") {
          this.commentLoading = false;
          this.markTaskAsVoid(this.id); 
          $(`#closeComment`).click();
          $(`#closeComment2`).click();
        } else {
          this.commentLoading = false;
          this.getTaskComment(); 
          $(`#closeComment`).click();
          $(`#closeComment2`).click();
          this.comment = "";
        this.type = "";
        this.selection = "";
          this.fetchTaskComment();
          this.generalSrv.sweetAlertSucess(data.message);
        }

      }, error => {
        $(`#closeComment`).click();
        this.generalSrv.sweetAlertError(this.generalSrv.getErrMsg(error))
      }).add(() => {
        this.isLoading = !this.isLoading;
        this.getTaskComment();
        this.fetchTaskComment();
      });
    }
  }

  getTaskComment() {
    // this.loader.showSpinner = true;
    this.generalTaskSrv.getCommentTask(this.id).pipe(takeUntil(this.unsubscribe)).subscribe(comments => {
      this.commentList = comments;
    })
  }

  selectionClick(value) {
    this.selection = value;
  }

  private markTaskAsCompleted(id) {
    const status = "COMPLETED"
    this.generalTaskSrv.markTaskStatus(id, status)
      .subscribe(() => {
        this.comment = "";
        this.type = "";
        this.selection = "";
        this.getTaskComment();
        this.fetchTaskComment();
        this.generalSrv.sweetAlertSucess("Your Task Has Been Marked As Completed");
      }, error => {
        this.generalSrv.sweetAlertError(this.generalSrv.getErrMsg(error));
      });
  }

  private markTaskAsVoid(id) {
    const status = "VOIDED"
    this.generalTaskSrv.markTaskStatus(id, status)
      .subscribe(() => {
        this.comment = "";
        this.type = "";
        this.selection = "";
        this.getTaskComment();
        this.fetchTaskComment();
        this.generalSrv.sweetAlertSucess("Your Task Has Been Terminated");
      }, error => {
        this.generalSrv.sweetAlertError(this.generalSrv.getErrMsg(error));
      });
  }

  //LOADER
  /**
  * Internet Loading
  * @param data 
  */
  initializeLoad(data) {
    if (data === null || data === undefined) {
      const setError = {
        title: "We couldn't load the data.",
        subTitle: "Kindly Check your Internet & Click Reload to try again.",
        action: "Reload",
        success: false
      };
      this.loader.dataless = setError;
      this.loader.spinnerType = "dataless";
    } else {
      this.task = data;
      this.loader.showSpinner = false;
    }
  }

  // Reload Spinner
  async reloadSpinner() {
    this.loader.spinnerType = this.loader.default;
    window.location.reload();
  }

  // Allow user to add a lead when there is none.
  async onActionState() {
    if (this.loader.dataless.success === true) $("#ModalCenter4").show();
    else await this.reloadSpinner();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}

